import React from 'react';
import { CalendarIcon } from 'lucide-react';
interface BrandTimelineProps {
  brand: {
    name: string;
    since: string;
  };
}
export function BrandTimeline({
  brand
}: BrandTimelineProps) {
  const milestones = [{
    year: '1931',
    title: 'Foundation',
    description: 'Vichy was founded in the spa town of Vichy, France'
  }, {
    year: '1950',
    title: 'Scientific Research',
    description: 'Established dermatological research center'
  }, {
    year: '1985',
    title: 'Global Expansion',
    description: 'Expanded to over 50 countries worldwide'
  }, {
    year: '2000',
    title: 'Innovation Leader',
    description: 'Launched breakthrough anti-aging formulas'
  }, {
    year: '2024',
    title: 'Sustainability',
    description: 'Committed to eco-friendly packaging and production'
  }];
  return <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1520" data-mp="2r4x3vyt69de3">
      <div className="text-center mb-12" data-id="element-1521" data-mp="2r3dkw0g4so8m">
        <div className="inline-flex items-center justify-center bg-blue-100 p-3 rounded-full mb-4" data-id="element-1522" data-mp="2ol4rl8b9tgf0">
          <CalendarIcon className="w-6 h-6 text-blue-600" data-id="element-1523" data-mp="2tkzllkqcem4a" />
        </div>
        <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-2" data-id="element-1524" data-mp="2fkya7bcgbwak">
          Our Journey
        </h2>
        <p className="text-gray-600" data-id="element-1525" data-mp="2kjrmj0g05h95">
          Over {new Date().getFullYear() - parseInt(brand.since)} years of
          excellence
        </p>
      </div>
      <div className="relative" data-id="element-1526" data-mp="38af8uqqo09f8">
        {/* Timeline Line */}
        <div className="hidden md:block absolute left-1/2 transform -translate-x-1/2 w-1 h-full bg-gradient-to-b from-blue-500 to-purple-500" data-id="element-1527" data-mp="3cbh28qxwhr9a"></div>
        <div className="space-y-12" data-id="element-1528" data-mp="2yhq043mi19nl">
          {milestones.map((milestone, index) => <div key={milestone.year} className={`relative flex items-center ${index % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'}`} data-id="element-1529" data-mp="33h2j2da91wkw" data-mpi={index}>
              {/* Content */}
              <div className="w-full md:w-5/12" data-id="element-1530" data-mp="3w115zmz4s9ag">
                <div className="bg-white rounded-xl shadow-lg p-6 hover:shadow-xl transition-all" data-id="element-1531" data-mp="9ord3dg5w9y6">
                  <div className="flex items-center gap-3 mb-3" data-id="element-1532" data-mp="4rr690bhn360">
                    <div className="bg-gradient-to-r from-blue-500 to-purple-500 text-white font-bold px-4 py-2 rounded-full" data-id="element-1533" data-mp="3vx0scgwd2xac">
                      {milestone.year}
                    </div>
                    <h3 className="font-bold text-gray-900 text-lg" data-id="element-1534" data-mp="3mwca19zxqarn">
                      {milestone.title}
                    </h3>
                  </div>
                  <p className="text-gray-600" data-id="element-1535" data-mp="3i41baagxkv0o">{milestone.description}</p>
                </div>
              </div>
              {/* Center Dot */}
              <div className="hidden md:block absolute left-1/2 transform -translate-x-1/2 w-6 h-6 bg-gradient-to-r from-blue-500 to-purple-500 rounded-full border-4 border-white shadow-lg" data-id="element-1536" data-mp="387g2de1sizrk"></div>
            </div>)}
        </div>
      </div>
    </div>;
}